import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

// Define the base endpoint for disease
const DISEASE_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.DISEASE,
  false // No tenant ID in the base URL
);

export const getDiseaseList = () => client.get(`${DISEASE_BASE}/list`);
